<template>
<div>
  <el-dialog class="accessoryDialog" v-model="dialogTableVisible" title="批量导出附件" v-loading.fullscreen.lock="loading" append-to-body :style="{ '--el-dialog-padding-primary': 0 }" header-class="batch-header-dialog" @close="close" width="724px">
    <el-container style="position: relative;margin-top:15px;padding: 5px 20px;">
      <el-tabs :style="{ '--el-tabs-header-height': '32px' }" v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="附件导出设置" name="first">
          <div class="selectArea">
            <div class="title">选择数据</div>
            <div class="radioArea">
              <el-radio v-model="radio" label="1" :disabled="submitDatas.approvingIds === ''?false:true">导出当前所有数据<p style="color:#999999;display:inline-block">（注：含没有使用筛选的所有数据或有使用筛选功能过滤出所有数据）</p></el-radio>
              <el-radio v-model="radio" label="2" :disabled="submitDatas.approvingIds === ''?true:false">导出选中所有数据</el-radio>
            </div>
          </div>
          <div class="selectArea">
            <div class="title">导出附件跟命名格式</div>
            <div class="hintArea">
              <div class="leftHintArea">
                <el-checkbox :indeterminate="isIndeterminate"
                              v-model="checkAll"
                              :disabled="isPDF"
                              @change="handleAllChange">全选所有附件</el-checkbox>
                <span style="width: 150px;display: inline-block;">导出模板</span>
                <span style="width: 80px;display: inline-block;">导出格式</span>
              </div>
              <div class="rightHintArea">
                <span v-show="templateValue != -2">导出命名格式</span>
              </div>
            </div>
            <div class="hintArea">
              <div class="leftHintArea">
                <el-checkbox v-model="isPDF" @change="pdfFun">导出打印PDF</el-checkbox>
                <!-- 默认模板和自定义的模板 -->
                <el-select size="small" v-model="templateValue" @change="templateChange" placeholder="请选择"  style="width: 150px">
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled">
                  </el-option>
                </el-select>
                <el-select size="small" v-model="formatValue" placeholder="请选择" style="width: 80px">
                  <el-option
                    v-for="item in formatOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled">
                  </el-option>
                </el-select>
              </div>
              <div class="rightHintArea">
                <!-- 国贸自定义导出简历的不要给他设置文件名字 -->
                <el-select size="small" v-model="selectPDF" @change="selectPdfFun" v-show="templateValue != -2">
                  <el-option value="" label="保持应用名字+提交日期" />
                  <el-option value="customize" label="自定义" />
                </el-select>
                
                <el-button v-if="selectPDF === 'customize'"
                            type="text"
                            @click="openPDF"
                            style="margin-left: 20px;">设置</el-button>
              </div>
            </div>
            <el-scrollbar class="scrollbarArea" style="height:234px;">
              <el-checkbox-group v-if="!isPDF" v-model="checkList" @change="handleChange">
                <!-- <el-checkbox :label="detail.name"
                  v-for="(detail,i) in showFromDatas"
                  :key="i">
                  <p class="checkboxName">{{detail.name}}</p>
                  <el-select v-model="detail.showFromValue" placeholder="请选择" :disabled="detail.canClick===false?true:false" @change="showFromChange(detail.showFromValue,i)">
                    <el-option
                      v-for="item in checkOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button class="setButton" :style="detail.canClick===false?'color:#666666':''" :disabled="detail.canClick===false?true:false" @click.native.prevent ="openSet(i,detail)" v-if="detail.showFromValue === 1">设置</el-button>

                </el-checkbox> -->
                <div class="itemsScro"
                    v-for="(detail,i) in showFromDatas"
                    :key="i">
                    <div class="itemsScroLeft">
                      <el-checkbox :label="detail.name">
                        <p class="checkboxName">{{detail.name}}</p>
                      </el-checkbox>
                    </div>

                    <div class="itemsScroRight">
                      <el-select v-model="detail.showFromValue" placeholder="请选择" :disabled="detail.canClick===false?true:false" @change="showFromChange(detail.showFromValue,i)">
                        <el-option
                          v-for="item in checkOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-button class="setButton" :style="detail.canClick===false?'color:#666666':''" :disabled="detail.canClick===false?true:false" @click.prevent ="openSet(i,detail)" v-if="detail.showFromValue === 1">设置</el-button>
                    </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
          </div>

        </el-tab-pane>
        <el-tab-pane label="查看导出记录" name="second">
          <div class="tab-list">
            <div :class="['tab-l', exports === 'file' ? 'tab-act' : '']"
                  @click="switchInfo('file')">附件</div>
            <div :class="['tab-l', exports === 'pdf' ? 'tab-act' : '']"
                  @click="switchInfo('pdf')">PDF</div>
          </div>
          <el-scrollbar v-show="exports === 'file'" class="scrollbarArea_second" style="height:394px;">
            <template v-if="recordList.length > 0">
              <div class="secondItem"
                    v-for="(item,i) in recordList"
                    :key="i">
                <div class="secondItemTop">
                  <p>{{item.name}}</p>
                  <el-tooltip class="item" effect="dark" content="刷新" placement="top">
                    <i class="iconfont icon-shuaxin blue" style="cursor:pointer" @click="refresh(i,item)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <i :class="item.status !== 0?'iconfont icon-shanchu5 red':'iconfont icon-shanchu5 gray'" :style="item.status !== 0?'cursor:pointer':'cursor:default'" @click="deleted(i,item)"></i>
                  </el-tooltip>
                </div>
                <template v-for="(item2,j) in item.listzip">
                  <div class="secondItemCenter"
                        v-if="item.status === 0 || item.status === 1"
                        :key="j">

                    <div class="kuai" v-if="item2.status === 1">
                      <i class="iconfont icon-fujian1 blue" style="margin-left:0px"></i>
                      <p>{{item2.name}}</p>
                      <el-tooltip class="item" effect="dark" content="下载" placement="top">
                        <i class="iconfont icon-xiazai blue" style="cursor:pointer" @click="upload(item2.url)"></i>
                      </el-tooltip>
                    </div>
                    <div class="kuai" v-if="item2.status === 0">
                      <i class="iconfont icon-fujian1 blue" style="margin-left:0px"></i>
                      <p>此压缩包数据有误，不支持下载</p>
                    </div>


                  </div>
                </template>
                <!-- 打包中 -->
                <div class="secondItemCenter" v-if="item.status === 0">
                  <div class="kuai">
                    <i class="iconfont icon-fujian1 blue" style="margin-left:0px"></i>
                    <p>打包生成中，如需知道进度请点击刷新按钮</p>
                  </div>
                </div>
                <!-- 空包 -->
                <div class="secondItemCenter" v-if="item.status === 2">
                  <div class="kuai">
                    <i class="iconfont icon-fujian1 blue" style="margin-left:0px"></i>
                    <p>此压缩包无数据，不支持下载</p>
                  </div>
                </div>
                <!-- 异常包 -->
                <div class="secondItemCenter" v-if="item.status === 3">
                  <div class="kuai">
                    <i class="iconfont icon-fujian1 blue" style="margin-left:0px"></i>
                    <p>此压缩包数据有误，不支持下载</p>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="recordList.length === 0">
              <div class="hint">
                暂无数据
              </div>
            </template>
          </el-scrollbar>
          <el-scrollbar v-show="exports === 'pdf'"
                        v-loading="pdfLoading"
                        class="scrollbarArea_second"
                        style="height:394px;">
            <template v-if="pdfList.length > 0">
              <div class="secondItems" v-for="(item, i) in pdfList" :key="item.pdfZipId">
                <p>{{item.name}}</p>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <i :class="item.status !== 0?'iconfont icon-shanchu5 red':'iconfont icon-shanchu5 gray'" :style="item.status !== 0?'cursor:pointer':'cursor:default'" @click="deletedPDF(i,item.pdfZipId)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="下载" placement="top">
                  <i class="iconfont icon-xiazai blue" style="cursor:pointer" @click="upload(item.url)"></i>
                </el-tooltip>
              </div>
            </template>
            <template v-else>
              <div class="hint">
                暂无数据
              </div>
            </template>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>

    </el-container>
    <template #footer>
      <div class="footer_second" v-if="activeName==='second' && (recordList.length > 0 || pdfList.length > 0)">
        <i class="iconfont icon-tixing" style="color:#999999"></i>
        <span>打包生成的文件将于30天后失效，请及时下载</span>
      </div>
      <div class="footer" v-if="activeName==='first'">
        <el-button size="medium" @click="close">取 消</el-button>
        <el-button type="yeprimary" size="medium" @click="downloadCustom" v-if="isPDF && templateValue !== -1">下载</el-button>
        <el-button type="yeprimary" size="medium" @click="submit" v-else>生成下载链接</el-button>
      </div>
    </template>
    <div class="loading-mask" v-show="isShowResume">下载中,请稍后......</div>
  </el-dialog>
  <!-- 附件字段设置 -->
  <fieldSet ref="fieldSetRef" v-if="fieldSetShow === true"></fieldSet>
  <!-- 打印预览 -->
  <print-box 
    ref="printBox" 
    :key=" 'print' + printBoxKey"
    v-model:isView="printBoxShow"
    v-model:isOpen="printBoxOpen"
    :isAllFiles="true"
    :allFileData="PDFAllData"
    :formdata="PDFData"
    :detailConfig="printBoxConfig"
    @close="printBoxKey++"></print-box>
  <!-- 国贸简历 -->
  <resumeForm v-if="isShowResume" :idList="resumeIDList" :downType="formatValue" @over-down="isDowning = false; isShowResume = false"></resumeForm>
  
</div>
</template>
<script>
import {axiosBase} from '@/api/api'
import fieldSet from './fieldSet.vue';
import { openapiGetuserapprovinglist } from "@/port/clientSide/oaExamine";
import { 
  openapiGetapproval,
  apiGetapprovalselection} from "@/port/clientSide/oaExamineAudit";
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import { batchexportpdf, getpdfZiplist, deletepdfzipbyid } from "@/port/clientSide/workbench";
import { getTemplateText, getHtmlName } from '@/util/survivalHTML'
import { formatDate } from '@/api/global'
import printBox from "@/components/common/detailEdit/excel/printBox.vue"

import { sheetDefaultConfig } from '@/components/common/detailEdit/detailConfig.js'
// import resumeForm from "@/pages/resumeForm"
import axios from 'axios'

export default {
  name: "accessoryComp",
  props: {
    date: {
      type:Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      radio: '1',//- 选择数据类型radio
      activeName: 'first',//- 选项卡参数
      loading: false,//- 附件组件显示加载
      dialogTableVisible: false,//- 附件组件显示参数
      checkList: [],//- 附件组件字段选择
      //- 附件组件字段选择内容和值
      checkOptions: [{
        value: 0,
        label: '保持文件原始名称'
      }, {
        value: 1,
        label: '自定义'
      }],
      checkboxValue: '',
      fieldSetShow: false,//- 字段设置显示
      isIndeterminate: true,
      checkAll: false,
      submitDatas: {},//- 提交后台参数（重要）
      dataFrom: [],//- 报表字段数据（重要）
      showFromDatas: [],//- 导出附件和命名格式内容
      recordList: [],//- 导出记录列表
      querys: "{}",//- 外部表单验证数据
      // pdf 相关
      isPDF: false,
      selectPDF: '',
      selectPdfArr: [],
      exports: 'file',
      pdfList: [],
      pdfLoading: false,
      templateValue: -1,
      templateOptions: [{
        value: -1,
        label: '默认',
        disabled: false
      }],
      formatValue: 'pdf',
      formatOptions: [{
          value: 'pdf',
          label: 'PDF',
          disabled: false
        }, {
          value: 'png',
          label: '图片',
          disabled: false
        }, {
          value: 'doc',
          label: '文档',
          disabled: false
      }],
      PDFAllData: [], // 全部数据
      PDFData: {}, // 用于导出pdf的数据
      printBoxShow: false, // 打印预览数据的显示隐藏
      printBoxOpen: false, // 打印预览弹窗的显示隐藏
      printBoxKey: 0, // 用于刷新组件
      printBoxConfig: sheetDefaultConfig, // 传入打印盒子的配置
      printBoxConfigList: {}, // 打印所有的模板列表
      isShowResume: false, // 是否显示国贸简历
      resumeIDList: [],
      isDowning: false, // 是否在下载中
      appName: '',
      isSpace: false,
      isUpace: false,
      dataLen: 0
    }

  },
  components: {
    'fieldSet': fieldSet,
    printBox,
    // resumeForm
    
  },
  mounted() {
    console.log("accessory启动执行了");
  },
  unmounted(){
    console.log("accessory需要销毁");
  },
  watch:{
    activeName(val){
      console.log("activeName",val)
      if(val === 'second'){
        this.getRecordList();
      }
    },
    PDFAllData: {
      handler (val) {
        if (val.length > 0 && val.length === this.dataLen) {
          this.printBoxShow = true // 渲染打印模板
        }
      },
      deep: true,
    },
    templateValue: {
      handler(val) {
        // 模板是默认值只能导出pdf
        if (val === -1) {
          this.formatValue = 'pdf'
          this.formatOptions = this.formatOptions.map(item => {
            if (item.value !== 'pdf') {
              item.disabled = true
            }
            return item
          })
        } else {
          this.formatOptions = this.formatOptions.map(item => {
            item.disabled = false
            return item
          })
        }
      },
      immediate: true
    },
    radio: {
      handler(val) {
        if (val == 2) {
          const urlList = ['http://10.66.99.244', 'http://10.66.99.244:8088', 'https://admin.itgedu.com.cn:6352', 'http://app.itgedu.com.cn']
          if (this.submitDatas.approvalId === 174 && urlList.indexOf(this.$url) !== -1) {
            this.templateOptions.push({
              value: -2,
              label: '简历',
              disabled: false
            })
          }
        }
      },  
      immediate: true
    }
  },
  methods: {
    // 选择打印模板
    templateChange (val) {
      console.log(val)
    },
    deletedPDF (i, id) {
      this.$confirm('确定要删除选中压缩包吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.pdfLoading = true;
        const res = await deletepdfzipbyid({ pdfZipId: id });
        if (res.code === 0) {
          this.pdfList.splice(i, 1);
        }
        this.pdfLoading = false;
      })
    },
    switchInfo (val) {
      if (val === 'pdf') this.getPdfList();
      this.exports = val
    },
    selectPdfFun (val) {
      if (val === 'customize') {
        this.openPDF()
      } else {
        this.selectPdfArr = []
      }
    },
    openPDF () {
      this.fieldSetShow = true
      this.$nextTick(() => {
        // 明细的不能被选，不然无法确定当前选择的是哪条数据
        const arr = (this.dataFrom || []).filter(item => {
          if (!item.fatherType) return item
        })
        this.$refs.fieldSetRef.openFieldSet(arr, '', this.selectPdfArr);
      })
    },
    pdfFun (val) {
      if (val) this.checkAll = false
    },
    // 获取审批按钮列表
    async getButtonList () {
      const res = await apiGetapprovalselection({}).catch(err => { console.log(err) })
      if (res.code === 0) {
        return (res.data).map(item => { return item ? item.split('|') : [] })
      }
    },
    // 批量生成pdf
    async batchPDF (actions) {
      const arr = [];
      const len = Math.floor((1 / this.date.length) * 100);
      const buttonText = await this.getButtonList()
      let batchData = []
      if (this.radio == 2) {
        batchData = this.submitDatas.approvingIds.split(',').map(item=> {
          return this.date.find(item1 => {
            return item1.approvingId == item
          })
        })
      } else {
        batchData = this.date
      }
      for (const i of batchData) {
        const res = await openapiGetuserapprovinglist({
          curpage: 0,
          pagesize: 0,
          approvingId: i.approvingId,
          approvalId: this.submitDatas.approvalId
        }).catch(err => { console.log('获取出错', err) });
        if (res.code === 0) {
          const formdata = JSON.parse(res.data[0].approving.formdata);
          const status = res.data[0].status;
          const template = await this.getTemplate(res.data[0].approving.ctime, i.userApprovingId);
          // template.ctime = formatDate(new Date(res.data[0].approving.ctime), 'yyyy-MM-dd')
          // console.log('查看模板', template)
          const text = getTemplateText({ ...template, formdata: formdata, process: res.data, status: status, buttonText: buttonText });
          // console.log('生成的模板', text)
          // return
          // 这里需要吧 text 上传上去
          const blob = new Blob([text],{type : 'text/html'});
          const name = (this.selectPDF ? getHtmlName({ formdata: formdata, arr: this.selectPdfArr, process: res.data[0] }) : (template.appname + template.ctime)) + ".txt";
          const file = new File([blob], name);
          const formData = new FormData();
          const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
          formData.append("file", file);
          const url = this.$apiurl + '/api/uploadhtml?accesstoken=' + token
          const html = await axios.post(url, formData, { "Content-Type": "multipart/form-data" }).catch(err => { console.log(err) })
          if (html) {
            arr.push(html.data)
            actions.upLoading(arr.length * len)
          }
        }
      }

      // 下载
      const batchRes = await batchexportpdf({ htmlnames: arr, approvalId: this.submitDatas.approvalId }).catch(err => { console.log('批量结果错误', err) });
      if (batchRes) {
        actions.fromParent({ isShow:false })
        this.getPdfList();
        this.activeName = 'second';
        this.exports = "pdf";
      }
    },
    async getTemplate (time, userApprovingId) {
      let obj = { approvalId: this.submitDatas.approvalId, userApprovingId: userApprovingId }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        obj.upaceid = upaceId
      }
      const res = await openapiGetapproval(obj);
      if (res.code === 0) {
        console.log('获取模板', res)
        let schoolName = '';
        let userMsg_external = localStorage.getItem("userMsg_external"); //- 新增外链模式下面的userMsg
        // 正常进来待确认
        if (userMsg_external) {
          userMsg_external = JSON.parse(userMsg_external);
          schoolName = userMsg_external.schoolMsg.name;
        }/* else {
          schoolName = this.userMsg.schoolMsg&&this.userMsg.schoolMsg.name;
        }*/

        return {
          appname: res.data.appname,
          ctime: formatDate(new Date(time || res.data.ctime), 'yyyy-MM-dd'),
          property: JSON.parse(res.data.property),
          schoolName: schoolName
        }
      }
    },
    // 查询pdf 列表
    async getPdfList () {
      this.pdfLoading = true;
      const res = await getpdfZiplist({ approvalId: this.submitDatas.approvalId, curpage: 1, pagesize: 9999 });
      if (res.code === 0) {
        // 市局专用
        const host = document.domain //获取域名
        if (host === 'yqfk.xmedu.cn') {
          const token = JSON.parse(window.localStorage.getItem('user')).accesstoken
          res.data = res.data.map(its => {
            its.url += ('?accesstoken=' + token)
          });
        }
        this.pdfList = res.data
      }
      this.pdfLoading = false
    },
      //- 删除
      deleted(index,item){
        const that = this;
        console.log("deleted",index,item);
        if(item.status !== 0){
          that.$confirm('确定要删除选中压缩包吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //- 可以删除状态
            axiosBase({zipgroupId: item.zipgroupId},"/api/deletezipgroup").then(res => {
              if(res.code === 0){
                this.recordList.splice(index,1);
                that.$message({
                  type: 'success',
                  message: '删除成功!'
                });

              }
            })

          }).catch(() => {
          });

        }
      },
      //- 刷新
      refresh(index,item){
        axiosBase({zipgroupId: item.zipgroupId},"/api/getzipgroup").then(res => {
          if(res.code === 0){
            console.log("index===>",index,res.data);
            this.recordList[index] = res.data;
            this.$message({
              showClose: true,
              message: '刷新成功',
              type: 'success'
            });
          }
        })
      },
      //- 文件下载
      upload(urlAddress){
        if(urlAddress != ''){
          window.open(urlAddress);
        }else{
          this.$message.error('下载链接有误，为空，联系后台');
        }
      },
      //- 获取导出记录
      getRecordList(){
        const that = this;
        axiosBase({ziptype: that.submitDatas.ziptype,approvalId: that.submitDatas.approvalId},"/api/getzipgrouplist").then(res => {
          if(res.code === 0){
            this.recordList = [...res.data];

          }
        })
      },
      //- 字段设置返回数据
      SetReturnData(val,index){
        console.log("SetReturnData",val,index);
        // pdf 勾选了
        if (this.isPDF) {
          this.selectPdfArr = val
          return true
        }
        if(val.length === 0){
          //- 说明没有设置数据
          this.$message.error('未设置自定义格式，将默认保持文件原始名称');
          this.showFromDatas[index].showFromValue = 0;
          this.showFromDatas[index].list = [];
        }else{
          //- 说明有设置数据
          if (!index && index !== 0) {
            this.showFromDatas.forEach((item)=>{
              item.list = val
            })
          }else {
            this.showFromDatas[index].list = val;
          }
        }

      },
      //- 字段选择
      showFromChange(val,index){
        console.log("showFromChange",val);
        if(val === 0){
          this.showFromDatas[index].list = [];
        }else{
          this.openSet(index,this.showFromDatas[index]);
        }
      },
      //- 打开导出附件组件
      openAccessory(val,querys) {
        console.log('querys==',val)
        this.dialogTableVisible = true;
        this.submitDatas = JSON.parse(JSON.stringify(val));
        if(this.submitDatas.approvingIds !== ''){
          this.radio = '2';
        }
        this.loading = false;
        if(querys){
          this.querys = querys;
        }

      },
      //- 设置报表字段数据
      setFromDatas(datas, printConfig, appname) {
        datas = JSON.parse(JSON.stringify(datas));
        this.appName = appname
        let showFromDatas = [];
        datas.forEach((item) => {
          // if(['image', 'file', 'ready-widget', 'label', 'checkbox', 'richTextWid'].indexOf(item.type) !== -1){
          if(item.type === 'image' || item.type === 'file'){
            item.showFromValue = 0;
            item.list = [];
            item.canClick = false;
            showFromDatas.push(item);
          }
        });

        this.showFromDatas = showFromDatas;
        this.dataFrom = datas;
        console.log("dataFrom===>",this.dataFrom)
        // 获取打印模板 )
        if (Array.isArray(printConfig) && printConfig[3]) {
          this.printBoxConfigList = printConfig[3].printConfig
          
          printConfig[3].printConfig.forEach(item => {
            this.templateOptions.push({
              label: item.canvasName,
              value: item.id,
            })
          })
        }
      },
      //- 关闭导出附件组件
      close() {
        console.log("执行关闭close");
        this.dialogTableVisible = false;
        this.$parent.downLoadShow = false;
        Object.assign(this.$data, this.$options.data.call(this))
      },
      // 下载自定义模板
      async downloadCustom () {
        this.PDFAllData = []
        //  == -2 就去下载国贸的简历 针对国贸独立开发的
        if (this.templateValue == -2) {
          await this.downResume()
          return false
        } 
        // 获取模板的配置
        const index = this.printBoxConfigList.findIndex(item => {
          return item.id == this.templateValue
        })
        this.printBoxConfig = this.printBoxConfigList[index] 
        // 获取全部数据
        let { code, data } = await axiosBase({
          curpage: 0,
          pagesize: 0,
          approvalId: this.submitDatas.approvalId
        }, '/api/getapprovinglist')
        if (code === 0) {
          this.dataLen = data.length
          this.printBoxOpen = true
          let approvingIds = []
          if (this.radio == 2) {
            approvingIds = this.submitDatas.approvingIds.split(',').map(item=> {
              return Number(item)
            })
          } else {
            approvingIds = this.date.map(item=> {
              return Number(item.approvingId)
            })
          }
          if (approvingIds.length > 0) {
            data = data.filter(item => {
              return approvingIds.includes(item.approvingId)
            })
          }
          this.dataLen = data.length
          for (let index in data) {
            const item = data[index]
            let formdata = JSON.parse(item.formdata)
            // 文件命名格式
            const name = (this.selectPDF ? getHtmlName({ formdata: formdata, arr: this.selectPdfArr, process: item }) : (this.appName + item.ctime))
            formdata.fileName = name
            // 文件格式类型
            formdata.fileType = this.formatValue
            const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
            const defaultKey = {}
            // 获取默认字段的数据
            defaultKeyList.forEach(item1 => {
              defaultKey[item1] = DealPrintData.handleDefaultKey(item1, item)
            })
            formdata = { ...formdata, ...defaultKey }
            // 获取其他表数据
            if (this.printBoxConfig.dataSource.formList && this.printBoxConfig.dataSource.formList.length > 0) {
              let spaceId, upaceId
              if (this.isSpace) {
                spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
              }
              else if (this.isUpace) {
                upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
              }
              DealPrintData.getOtherApproval(this.printBoxConfig, formdata, spaceId, upaceId).then(({otherData}) => {
                formdata = { ...formdata, ...otherData }
                this.PDFAllData.push(formdata)
              })
            } else {
              this.PDFAllData.push(formdata)
            }
          }
        }
      },
      
      // 下载国贸的简历
      downResume() {
        if (this.submitDatas.approvingIds) {
          const checkID = this.submitDatas.approvingIds.split(',').map(item=> {
            return Number(item)
          }) // 选中的人
          this.resumeIDList = this.date.filter(item => {
            return checkID.indexOf(item.approvingId) !== -1
          }).map(item => {
            return item['x1658998854474'] || ''
          })
          this.isShowResume = true
        }
        
      },
      
      //- 提交导出附件组件
      submit() {
        // 如果是批量pdf 就直接过去
        if (this.isPDF) {
          const self = this
          this.$statusMsg.loadingMsg({
            additionalTips: '数据导出中...',
            schedule: 0,
            confirmFun: async (actions) => {
              self.batchPDF(actions);
            }
          })

          return false
        }
        const that = this;
        let submitDatas =JSON.parse(JSON.stringify( that.submitDatas));
        let showFromDatas = JSON.parse(JSON.stringify(that.showFromDatas));
        let checkList = JSON.parse(JSON.stringify(that.checkList));
        if(checkList.length === 0){
          //- 没有选择导出附件字段
          that.$message.error('请先选择附件，再生成下载链接');
          return;
        }
        if(this.radio === '1'){
          //- 导出选中数据
          submitDatas.approvingIds = '';
        }

        let new_showFromDatas = [];
        if(this.checkAll === true){
          //- 全选时的提交数据内容
          submitDatas.zipcontent = JSON.stringify(showFromDatas);
        }else{
          //- 非全选时的提交数据内容
          checkList.forEach((item)=>{
            showFromDatas.forEach((item2)=>{
               if(item === item2.name){
                 new_showFromDatas.push(item2);
               }
            })
          })
          submitDatas.zipcontent = JSON.stringify(new_showFromDatas);
        }
        //- 增加表单验证过滤数据
        if(this.querys){
          submitDatas.querys = this.querys;
        }
        axiosBase(submitDatas,"/api/exportzip").then(res => {
          if(res.code === 0){
            that.activeName = 'second';//- 选项卡参数
          }
        })


      },
      //- tab切换
      handleClick(val) {
        console.log("handleClick",val)

      },
      //- 打开字段设置
      openSet(index,detail) {
        console.log("打开字段设置",index,detail);
        let tier = detail.tier;//- 控件登记
        let click_fatherType = detail.fatherType;//- 控件父级fatherType
        let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
        let showFromDatas = JSON.parse(JSON.stringify(this.showFromDatas));
        let Grade = [];
        if(tier === 1){
          //- 一级控件
          dataFrom.forEach((item)=>{
            if(item.tier === 1 && ['image', 'file'].indexOf(item.type) === -1){
              Grade.push(item);
            }
          })
          // console.log("firstGrade",firstGrade);
        }else{
          //- 二三级控件（新版关联或者明细等）
          dataFrom.forEach((item)=>{
            if(item.tier === 1 && ['image', 'file'].indexOf(item.type) === -1){
              Grade.push(item);
            }else if(item.tier === 2 && ['image', 'file'].indexOf(item.type) === -1){
              //- 二级控件
              if(item.fatherType === click_fatherType){
                Grade.push(item);
              }

            }else if(item.tier === 3 && ['image', 'file'].indexOf(item.type) === -1){
              //- 三级控件
              let item_father = item.fatherType.split(".");
              if(item_father[0] === click_fatherType ){
                Grade.push(item);
              }
            }




            // if(['image', 'file'].indexOf(item.type) === -1 ){

            //   Grade.push(item);
            // }
          })
          // console.log("otherGrade",otherGrade)
        }

        this.fieldSetShow = true;
        this.$nextTick(()=>{
          // 选择列表 下标 选中的
          console.log('打开', Grade,index,showFromDatas[index].list)
          this.$refs.fieldSetRef.openFieldSet(Grade,index,showFromDatas[index].list);
        })
      },
      //- 全选
      handleAllChange(val) {
        console.log("handleAllChange",val);
        let showFromDatas = this.showFromDatas;
        this.checkList = [];
        if(val === true){
          //- 全选
          showFromDatas.forEach((item)=>{
            this.checkList.push(JSON.parse(JSON.stringify(item.name)));
            item.canClick = true;
          })
        }else{
          //- 取消
          showFromDatas.forEach((item)=>{
            item.canClick = false;
          })
        }
        this.isIndeterminate = false;
      },
      //- 单选
      handleChange(val) {
        let showFromDatas = this.showFromDatas;
        showFromDatas.forEach((item)=>{
          item.canClick = false;
        })
        val.forEach((item)=>{
          console.log("item",item);
          let index = showFromDatas.findIndex((FromItem)=>{ return item === FromItem.name})
          showFromDatas[index].canClick = true;
        })
      },

  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  }
}
</script>
<style lang="scss">
  ::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
    transition: none;
  }
.accessoryDialog {
  .el-tabs__header.is-top {
    border: none;
    color: #4e86ff;
    .el-tabs__item {
      color: #4e86ff;
      height: 30px;
      line-height: 30px;
      padding: 0 12px;
      &:hover {
        color: #333333;
      }
      &.is-active {
        color: #fff;
        background: #4e86ff;
        border: none;
      }
    }
  }
  .el-tabs__nav {
    border: 1px solid #4e86ff !important;
    border-radius: 4px !important;
  }
  .el-tabs__content {
    margin-top: 20px;
    .selectArea {
      width: 100%;
      margin-bottom: 10px;
      .title {
        font-size:14px;
        color:#333333;
        margin-bottom: 12px;
        font-weight: bold;
      }
      .radioArea {
        width: 100%;
        font-size:14px;
        color:rgba(51,51,51,1);
        .el-radio {
          width: 100%;
          .el-radio__input.is-checked+.el-radio__label {
            color: #333333;
          }

        }

      }
      .hintArea {
        width: 100%;
        color:rgba(153,153,153,1);
        font-size:14px;
        display: flex;
        align-items: center;
        .leftHintArea {
          width: 69%;
          display: inline-block;
        }
        .rightHintArea {
          flex: 1;
          display: flex;
          align-items: center;
          ::v-deep .el-select {
            margin-left: 4px;
          }
        }
      }
      .scrollbarArea {
        width: 684px;
        background: rgba(255,255,255,1);
        border-radius: 4px;
        border: 1px solid rgba(229,229,229,1);
        margin-top: 9px;
        .el-scrollbar__wrap {
          overflow-x: hidden !important;
          width: 100%;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .itemsScro {
          width: 100%;
          margin-top: 10px;
          .itemsScroLeft {
            width: 60%;
            display: inline-block;
            padding-left: 7.9px;
            .el-checkbox {
              width: 50%;
              padding-left: 3%;
              padding-top: 5px;
              margin-right: 0;

            }

          }
          .itemsScroRight {
            width: 38%;
            display: inline-block;
            /*padding-left: 26px;*/
            text-align: right;
            .el-checkbox__label {
              width: 96%;
              .checkboxName {
                width: 62%;
                height: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
                margin-top: 6px;
                vertical-align: top;
              }
            }
            .el-select {
              width: 160px;
              input {
                height: 30px;
                line-height: 30px;
              }
              .el-select__caret.el-input__icon {
                line-height: 30px;
              }
            }
            .setButton {
              color: #4284ba;
              height: 30px;
              line-height: 0px;
              border: none;
              &:hover {
                background: white;
              }
            }
          }


        }
      }
    }
    .scrollbarArea_second {
      width: 683px;
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .secondItem {
        background:rgba(255,255,255,1);
        border-radius:4px;
        width: 96%;
        border:1px solid rgba(210,210,210,1);
        padding: 10px;
        margin-bottom: 10px;
        .secondItemTop {
          width: 100%;
          font-size:14px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          p {
            width: 91%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;

          }
          i {
            display: inline-block;
            vertical-align: top;
            margin-left: 8px;
            &.blue {
              color: #4284BA;
            }
            &.red {
              color: #D44C4C;
            }
            &.gray {
              color: #999999;
            }

          }
        }
        .secondItemCenter {
          width: 100%;
          font-size:14px;
          color:#666666;
          margin-top: 10px;
          .kuai{
            width: 100%;
            p {
              width: 88%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;

            }
            i {
              display: inline-block;
              vertical-align: top;
              margin-left: 8px;

              &.blue {
                color: #4284BA;
              }
              &.icon-xiazai,&.icon-fujian1{
                font-size: 20px;
                margin-top: -4px;
              }
              &.icon-xiazai {
                margin-left: 2px;
                font-size: 20px;
              }


            }

          }

        }
      }
      .secondItems {
        background:rgba(255,255,255,1);
        border-radius:4px;
        width: 96%;
        border:1px solid rgba(210,210,210,1);
        padding: 10px;
        margin-bottom: 10px;
        position: relative;
        display: flex;
        align-items: center;
        p {
          width: calc(100% - 50px);
        }
        i {
          display: inline-block;
          vertical-align: top;
          margin-left: 8px;
        }
        .blue {
          color: #4284BA;
        }
        .red {
          color: #D44C4C;
        }
      }
      .hint {
        width: 100%;
        text-align: center;
        margin-top: 17.9%;
        color: #999999;
        font-size: 14px;
      }
    }
  }
  .tab-list {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .tab-l {
      margin-right: 20px;
      color: #333333;
      cursor: pointer;
    }
    .tab-act {
      color: #4e86ff;
      position: relative;
      &::before {
        content: ' ';
        width: 100%;
        height: 2px;
        background: #4e86ff;
        border-radius: 1px;
        position: absolute;
        bottom: -4px;
        left: 0;
      }
    }
  }
  .footer {
    text-align: right;
    padding: 20px;
    padding-top: 10px;
  }
  .footer_second {
    text-align: left;
    padding: 4px 0px;
    color: #666666;
  }
}
.loading-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}
</style>
